<template>
  <div
    :aria-label="$t('editor.controlpanel.arialabel')"
    class="editor-control-panel flex gap-150 items-center justify-center w-full rounded-full bg-primary-primary my-none mx-auto py-050 px-100"
    role="group"
  >
    <template v-for="(action, index) in actions" :key="action.id">
      <span
        v-if="index > 0"
        aria-hidden="true"
        class="separator my-050 mx-none rounded-full bg-lightblue-500"
      />

      <LcButton
        :aria-label="action.ariaLabel"
        class="segment"
        :class="[
          disabled || action.disabled
            ? 'segment--disabled'
            : `segment--${action.variant ?? 'fade'}`,
        ]"
        :disabled="disabled || action.disabled"
        :icon="action.icon"
        no-padding
        size="large"
        variant="tertiary"
        @click="emit('click', action.id)"
      >
        {{ action.label }}
      </LcButton>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { ControlPanelAction } from '../@types/editor'

type Emits = {
  (event: 'click', id: string): void
}

type Props = {
  actions: ControlPanelAction[]
  disabled?: boolean
}

defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.editor-control-panel {
  max-width: 30rem;
  box-shadow: token('shadow/shadow/card/large');

  .segment {
    flex: 1 1 auto;
    height: token('size/button/height-m');
    padding: token('size/space/gap/none');

    &--prominent {
      color: token('color/text/accent/prominent/accent-prominent');
    }
  }

  .separator {
    flex: 0 0 auto;
    align-self: stretch;
    width: token('size/border/100');
  }
}
</style>
